/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CommentDtoGenericApiResponseFromJSON, CommentRequestToJSON, FileDtoListGenericApiResponseFromJSON, Int32GenericApiResponseFromJSON, ServiceActionCreateUpdateDtoToJSON, ServiceActionDtoGenericApiResponseFromJSON, ServiceActionListDtoSortedPagedListResponseGenericApiResponseFromJSON, ServiceActionTypeDtoGenericApiResponseFromJSON, ServiceActionTypeDtoListGenericApiResponseFromJSON, ServiceTaskCreateDtoToJSON, ServiceTaskCreateDtoGenericApiResponseFromJSON, ServiceTaskDtoGenericApiResponseFromJSON, ServiceTaskDtoListGenericApiResponseFromJSON, ServiceTaskListDtoSortedPagedListResponseGenericApiResponseFromJSON, ServiceTaskUpdateDtoToJSON, SuccessfullApiResponseFromJSON, } from '../models';
/**
 *
 */
export class ServiceActionApi extends runtime.BaseAPI {
    /**
     */
    apiServiceActionAddAttachmentsPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.serviceActionId !== undefined) {
                queryParameters['serviceActionId'] = requestParameters.serviceActionId;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.request) {
                requestParameters.request.forEach((element) => {
                    formParams.append('request', element);
                });
            }
            const response = yield this.request({
                path: `/api/ServiceAction/AddAttachments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionAddAttachmentsPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionAddAttachmentsPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionAddCommentTaskIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
                throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling apiServiceActionAddCommentTaskIdPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/ServiceAction/AddComment/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CommentRequestToJSON(requestParameters.commentRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CommentDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionAddCommentTaskIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionAddCommentTaskIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionAddPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/ServiceAction/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ServiceActionCreateUpdateDtoToJSON(requestParameters.serviceActionCreateUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionAddPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionAddPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionAddTaskAttachmentsPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.serviceTaskId !== undefined) {
                queryParameters['serviceTaskId'] = requestParameters.serviceTaskId;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.request) {
                requestParameters.request.forEach((element) => {
                    formParams.append('request', element);
                });
            }
            const response = yield this.request({
                path: `/api/ServiceAction/AddTaskAttachments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionAddTaskAttachmentsPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionAddTaskAttachmentsPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionAddTaskPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.serviceActionId !== undefined) {
                queryParameters['serviceActionId'] = requestParameters.serviceActionId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/ServiceAction/AddTask`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ServiceTaskCreateDtoToJSON(requestParameters.serviceTaskCreateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceTaskCreateDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionAddTaskPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionAddTaskPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionAddTypePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/AddType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceActionTypeDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionAddTypePost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionAddTypePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionDeleteAttachmentDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.serviceActionId !== undefined) {
                queryParameters['serviceActionId'] = requestParameters.serviceActionId;
            }
            if (requestParameters.fileId !== undefined) {
                queryParameters['fileId'] = requestParameters.fileId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/DeleteAttachment`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionDeleteAttachmentDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionDeleteAttachmentDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionDeleteCommentCommentIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
                throw new runtime.RequiredError('commentId', 'Required parameter requestParameters.commentId was null or undefined when calling apiServiceActionDeleteCommentCommentIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/DeleteComment/{commentId}`.replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionDeleteCommentCommentIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionDeleteCommentCommentIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionDeleteIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiServiceActionDeleteIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionDeleteIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionDeleteIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionDeleteTaskAttachmentDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.serviceTaskId !== undefined) {
                queryParameters['serviceTaskId'] = requestParameters.serviceTaskId;
            }
            if (requestParameters.fileId !== undefined) {
                queryParameters['fileId'] = requestParameters.fileId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/DeleteTaskAttachment`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionDeleteTaskAttachmentDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionDeleteTaskAttachmentDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionDeleteTaskDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.id !== undefined) {
                queryParameters['id'] = requestParameters.id;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/DeleteTask`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionDeleteTaskDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionDeleteTaskDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionDeleteTypeDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.id !== undefined) {
                queryParameters['id'] = requestParameters.id;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/DeleteType`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionDeleteTypeDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionDeleteTypeDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionEditCommentCommentIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
                throw new runtime.RequiredError('commentId', 'Required parameter requestParameters.commentId was null or undefined when calling apiServiceActionEditCommentCommentIdPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/ServiceAction/EditComment/{commentId}`.replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CommentRequestToJSON(requestParameters.commentRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionEditCommentCommentIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionEditCommentCommentIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionFindByGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.filtersDateRangeStart !== undefined) {
                queryParameters['Filters.DateRangeStart'] = requestParameters.filtersDateRangeStart.toISOString();
            }
            if (requestParameters.filtersDateRangeEnd !== undefined) {
                queryParameters['Filters.DateRangeEnd'] = requestParameters.filtersDateRangeEnd.toISOString();
            }
            if (requestParameters.filtersRequired !== undefined) {
                queryParameters['Filters.Required'] = requestParameters.filtersRequired;
            }
            if (requestParameters.filtersStatus) {
                queryParameters['Filters.Status'] = requestParameters.filtersStatus;
            }
            if (requestParameters.filtersCarId !== undefined) {
                queryParameters['Filters.CarId'] = requestParameters.filtersCarId;
            }
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/FindBy`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceActionListDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionFindByGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionFindByGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionGetAllGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/GetAll`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceActionListDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionGetAllGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionGetAllGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionGetAllTasksForUserGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.filtersDateRangeStart !== undefined) {
                queryParameters['Filters.DateRangeStart'] = requestParameters.filtersDateRangeStart.toISOString();
            }
            if (requestParameters.filtersDateRangeEnd !== undefined) {
                queryParameters['Filters.DateRangeEnd'] = requestParameters.filtersDateRangeEnd.toISOString();
            }
            if (requestParameters.filtersStatus) {
                queryParameters['Filters.Status'] = requestParameters.filtersStatus;
            }
            if (requestParameters.filtersAssigneeId) {
                queryParameters['Filters.AssigneeId'] = requestParameters.filtersAssigneeId;
            }
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/GetAllTasksForUser`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceTaskListDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionGetAllTasksForUserGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionGetAllTasksForUserGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionGetIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiServiceActionGetIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/Get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceActionDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionGetIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionGetIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionGetTaskIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiServiceActionGetTaskIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/GetTask/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceTaskDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionGetTaskIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionGetTaskIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionGetTasksForServiceServiceActionIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.serviceActionId === null || requestParameters.serviceActionId === undefined) {
                throw new runtime.RequiredError('serviceActionId', 'Required parameter requestParameters.serviceActionId was null or undefined when calling apiServiceActionGetTasksForServiceServiceActionIdGet.');
            }
            const queryParameters = {};
            if (requestParameters.dateRangeStart !== undefined) {
                queryParameters['DateRangeStart'] = requestParameters.dateRangeStart.toISOString();
            }
            if (requestParameters.dateRangeEnd !== undefined) {
                queryParameters['DateRangeEnd'] = requestParameters.dateRangeEnd.toISOString();
            }
            if (requestParameters.status) {
                queryParameters['Status'] = requestParameters.status;
            }
            if (requestParameters.assigneeId) {
                queryParameters['AssigneeId'] = requestParameters.assigneeId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/GetTasksForService/{serviceActionId}`.replace(`{${"serviceActionId"}}`, encodeURIComponent(String(requestParameters.serviceActionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceTaskDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionGetTasksForServiceServiceActionIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionGetTasksForServiceServiceActionIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionGetTypesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/GetTypes`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ServiceActionTypeDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionGetTypesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionGetTypesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionUpdatePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/ServiceAction/Update`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ServiceActionCreateUpdateDtoToJSON(requestParameters.serviceActionCreateUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionUpdatePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionUpdatePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionUpdateStatusPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.status !== undefined) {
                queryParameters['status'] = requestParameters.status;
            }
            if (requestParameters.taskId !== undefined) {
                queryParameters['taskId'] = requestParameters.taskId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/ServiceAction/UpdateStatus`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionUpdateStatusPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionUpdateStatusPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionUpdateTaskPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/ServiceAction/UpdateTask`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ServiceTaskUpdateDtoToJSON(requestParameters.serviceTaskUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionUpdateTaskPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionUpdateTaskPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiServiceActionUpdateTypePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.id !== undefined) {
                queryParameters['id'] = requestParameters.id;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/ServiceAction/UpdateType`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiServiceActionUpdateTypePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiServiceActionUpdateTypePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
